var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item" }, [
    _c("div", {
      staticClass: "image-wrapper",
      style: { backgroundImage: "url(" + _vm.image + ")" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "content-wrapper" }, [
      _c("div", {
        staticClass: "item-vendor",
        domProps: { textContent: _vm._s(_vm.properties.designer) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "item-title",
        domProps: { textContent: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "item-price" }, [
        _vm.discounted_price == _vm.price
          ? _c("span", [_vm._v(_vm._s(_vm.$formatMoney(_vm.price)))])
          : _c("p", [
              _c("span", { staticClass: "original_price" }, [
                _vm._v(_vm._s(_vm.$formatMoney(_vm.price)))
              ]),
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$formatMoney(_vm.discounted_price)) +
                  "\n\t\t\t"
              )
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "quantity" }, [
        _c("p", [_vm._v(_vm._s(_vm.translation.item_quantity))]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "change",
            on: {
              click: function($event) {
                return _vm.change("subtract")
              }
            }
          },
          [_vm._v("-")]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "amount",
          domProps: { textContent: _vm._s(_vm.quantity) }
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "change",
            on: {
              click: function($event) {
                return _vm.change("add")
              }
            }
          },
          [_vm._v("+")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "remove",
        on: {
          click: function($event) {
            return _vm.change("remove")
          }
        }
      },
      [
        _c("p", [
          _vm._v("\n\t\t\t" + _vm._s(_vm.translation.remove)),
          _c("span", [
            _c(
              "svg",
              {
                attrs: {
                  width: "16px",
                  height: "16px",
                  viewBox: "0 0 16 16",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Symbols",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "UI/CartRemove",
                          transform: "translate(1.000000, 1.000000)",
                          "fill-rule": "nonzero",
                          stroke: "#969BA5"
                        }
                      },
                      [
                        _c("circle", {
                          attrs: { id: "Oval", cx: "7", cy: "7", r: "7" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2.5,7 L11.6376953,7",
                            id: "Line-6",
                            "stroke-linecap": "square"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }